<template>
    <el-dialog :visible.sync="centerDialogVisible" :width="dialogWidth+'px'"  center :show-close="showClose" :before-close="closeDialog" @opened="opened"  @closed="closed">
      <video ref="myVideo" class="my-video"  controls controlslist="nofullscreen" loop :height="videoHeight+'px'">
        <source :src="srcPath" type="video/mp4">
      </video>
    </el-dialog>
</template>

<script>
export default {
  name: 'Video-Dialog',
  data() {
    return {
      srcPath:"",
      isMobile: false,
      centerDialogVisible: false,
      showClose: false,
      videoState:false,
      dialogWidth:1000,
      videoHeight:562.5,
    }
  },
  created() {
        this.isMobile = window.isMobile
  },
  mounted() {
    if(this.isMobile){
      this.dialogWidth= document.documentElement.clientWidth-40
      this.videoHeight= this.dialogWidth*9/16
    }
  },
  methods: {
    openVideo(videoPath) {
      this.srcPath=videoPath
      this.centerDialogVisible = true
    },
    opened(){
      this.videoState = true;
      this.$refs.myVideo.play();
    },
    closed(){
      this.$refs.myVideo.pause();
      this.$refs.myVideo.currentTime=0;
    },
    closeDialog(){
      this.centerDialogVisible = false
    },
    onPause(){
      if (this.$refs.myVideo.paused) {
        this.$refs.myVideo.play();
        this.videoState = true;
      } else {
        this.$refs.myVideo.pause();
        this.videoState = false;
      }
    }
  },
}
</script>

<style scoped lang="scss">

@media only screen and (max-width: 1200px) {
  ::v-deep .el-dialog{
     background-color: #000000;
     margin-top: 30vh !important;
  }
}

@media only screen and (min-width: 1200px) {
  ::v-deep .el-dialog{
     background-color: #000000;
   
  }

}
 

  ::v-deep .el-dialog__header{
    padding: 0px;
  }

  ::v-deep .el-dialog--center .el-dialog__body{
    padding: 0px;
  }


  .my-video {
    background-color: #000000;
     width: 100%;
     border-radius: 2px;
     overflow: hidden;
  }
</style>
